import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';
import { IncidentClient, Incident, IncidentDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const incidentEventClient = new IncidentClient(apiBaseUrl);

function useCloseIncident() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<IncidentDTO, ProblemDetails, Incident>({
    mutationKey: [queryKeys.Incident.CloseIncident],
    mutationFn: (report: Incident) => incidentEventClient.closeIncident(report),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useCloseIncident;
